import { render, staticRenderFns } from "./NewPdfScreenshotViewer.vue?vue&type=template&id=3af5fc67&scoped=true"
import script from "./NewPdfScreenshotViewer.vue?vue&type=script&lang=js"
export * from "./NewPdfScreenshotViewer.vue?vue&type=script&lang=js"
import style0 from "./NewPdfScreenshotViewer.vue?vue&type=style&index=0&id=3af5fc67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5fc67",
  null
  
)

export default component.exports